module.exports = __webpack_public_path__ + "img/img29.e3240219.png";